import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
    >
      <path d="M5.263 16.393c-.44-5.258 4.566-5.435 4.566-5.435-1.669-.663-2.766-2.342-2.547-4.243.176-2.165 2.108-3.8 4.259-3.712 2.327.133 4.083 2.122 3.863 4.464a4.07 4.07 0 0 1-2.546 3.49s2.107.09 3.468.487c2.063.619 6.015 7.733 1.01 8.043-3.907.22-6.454-1.856-4.785-3.27 1.624-1.37 3.731 5.082-3.161 4.772" />
      <path
        d="M17.336 19.487c-3.907.221-6.453-1.856-4.785-3.27 1.624-1.37 3.731 5.082-3.161 4.773"
        style={{
          stroke: "var(--icon-accent,#E47B53)",
        }}
      />
    </g>
  </svg>
);
export const IndividualIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
